exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".env-digital {\n  display: flex;\n  flex-direction: row;\n  flex-flow: wrap;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n}\n.env-digital>section {\n  margin-right: 24px;\n  margin-bottom: 20px;\n}\n", ""]);
